export default {
    meta: {
        title: '鱼你在一起-签约前申请保护',
        url: '/fishtogether/beforecontract',
        urlName: '签约前申请保护'
    }
};
